var md5 = require("md5");

const AUTH_USER = "authUser";

export function checkIsTokenAvailable() {
    var auth = JSON.parse(localStorage.getItem(AUTH_USER));
    if (auth) {
        return true;
    }
    else {
        return null;
    }
}

function checkIsWithinLoginDuration() {
    var auth = JSON.parse(localStorage.getItem(AUTH_USER));
    if (auth) {
        const loginDuration = auth.loginTime + auth.expireInSeconds;
        const currentTime = new Date().getTime() / 1000;
        const accessToken = auth.accessToken;
        if (accessToken && currentTime < loginDuration) {
            return true;
        }
        else {
            return false;
        }
    }
    else {
        return false;
    }
}

export function getToken() {
    var auth = JSON.parse(localStorage.getItem(AUTH_USER));
    if (auth) {
        if (checkIsWithinLoginDuration) {
            return auth.accessToken;
        }
    }
    else {
        console.log("auth not found");
        return null;
    }
}

export function getEncryptedToken() {
    var auth = JSON.parse(localStorage.getItem(AUTH_USER));
    if (auth) {
        if (checkIsWithinLoginDuration) {
            return auth.encryptedAccessToken;
        }
    }
    else {
        // console.log("auth not found");
        return null;
    }
}

export function getTenantId() {
    var tenantId = JSON.parse(localStorage.getItem(TENANT_ID));
    return tenantId;
}

export function setToken(authInfo) {
    // console.log("setToken", authInfo);
    var authUser = { ...authInfo };
    // authUser.accessToken = authInfo.accessToken;
    // authUser.expireInSeconds = authInfo.expireInSeconds;
    // authUser.userId = authInfo.userId;
    authUser.loginTime = new Date().getTime() / 1000;
    return localStorage.setItem(AUTH_USER, JSON.stringify(authUser));
}

export function setTenantId(info) {
    return localStorage.setItem(TENANT_ID, JSON.stringify(info));
}

export function removeToken() {
    // console.log("AUTH_USER", AUTH_USER);
    return localStorage.removeItem(AUTH_USER);
}

export function removeTenant() {
    return localStorage.removeItem(TENANT_ID);
}

export function getAuthInfo(key) {
    var auth = JSON.parse(localStorage.getItem(AUTH_USER));
    return auth ? auth[key] : null;
}






// WEBPACK FOOTER //
// ./src/utils/auth.js